import assignToThis from '../../../helper/assignToThis';

export class ScenarioRenFrWind {

  public numberOfTurbineType1: number | null = null;
  public turbineModelType1: string | null = null;
  public unitPowerOfTurbineType1: number | null = null;
  public rotorDiameterType1: number | null = null;
  public numberOfTurbineType2: number | null = null;
  public turbineModelType2: string | null = null;
  public unitPowerOfTurbineType2: number | null = null;
  public rotorDiameterType2: number | null = null;

  public net_p50: number | null = null;
  public net_p90: number | null = null;

  public numberOfPdl: number | null = null;
  public numberOfPdlPtr: number | null = null;
  public numberOfPtr: number | null = null;
  
  public constructor(obj: object = {}) {
    assignToThis(this, obj);

  }

}
